import React from 'react';
import './CustomPopup.css';

const CustomPopup = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'error', // error, warning, success, info
  display = 'center', // center, top, bottom
  children 
}) => {
  if (!isOpen) return null;

  // Type based styling
  const typeStyles = {
    error: {
      bgColor: '#dc3545',
      icon: 'bi-exclamation-circle',
      title: 'Error'
    },
    warning: {
      bgColor: '#ffc107',
      icon: 'bi-exclamation-triangle',
      title: 'Warning'
    },
    success: {
      bgColor: '#198754',
      icon: 'bi-check-circle',
      title: 'Success'
    },
    info: {
      bgColor: '#0dcaf0',
      icon: 'bi-info-circle',
      title: 'Info'
    }
  };

  const style = typeStyles[type] || typeStyles.error;

  // Position styling
  const positionStyles = {
    center: 'popup-center',
    top: 'popup-top',
    bottom: 'popup-bottom'
  };

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div 
        className={`popup-container ${positionStyles[display]}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header" style={{ backgroundColor: style.bgColor }}>
          <div className="popup-title">
            <i className={`bi ${style.icon} me-2`}></i>
            <span>{title || style.title}</span>
          </div>
          <button 
            className="popup-close-btn" 
            onClick={onClose}
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        
        <div className="popup-body">
          {message && <p className="popup-message">{message}</p>}
          {children}
        </div>
        
        <div className="popup-footer">
          <button
            className="btn btn-danger w-100"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomPopup;